// extracted by mini-css-extract-plugin
export var editButton = "detailsPage-module--edit-button--a5180";
export var gridAriane = "detailsPage-module--grid-ariane--e73d6";
export var gridContent = "detailsPage-module--grid-content--3b7dc";
export var gridResume = "detailsPage-module--grid-resume--0f49b";
export var gridTags = "detailsPage-module--grid-tags--b8e22";
export var gridTitle = "detailsPage-module--grid-title--2de34";
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--84cbf";
export var pageBase = "detailsPage-module--page-base--70956";
export var pageContentFooter = "detailsPage-module--page-content-footer--5777e";
export var pageContentFooterBack = "detailsPage-module--page-content-footer-back--9e323";
export var pageImg = "detailsPage-module--page-img--17f63";
export var pageTitle = "detailsPage-module--page-title--80113";